import { NavLink } from "react-router";

import type { TypeFrais } from "../../types/TypeFrais";
import { useTrads } from "../../contexts/trads/useTrads";
import './TypeFrais.scss'

function TypeFraisItem({typefrais}:{typefrais:TypeFrais}) {
    const {translate}=useTrads();
    return (
        <div className="row">
            <div className="col-12 type-frais">
                <h2>{typefrais.name}</h2>
                <NavLink to={`/type_frais/${typefrais.id.toString()}/edit`}>{translate('btn_edit')}</NavLink>
                {typefrais.picto?
                <div className="picto">
                <img src={typefrais.picto.filename} width={typefrais.picto.size?.w} height={typefrais.picto.size?.h} title="" alt=""/>
                </div>
                :null}
            </div>
        </div>
    );
}
export default TypeFraisItem;